import React, { useState } from 'react'
import { Button, Divider, message, Tooltip } from 'antd'
import { isArray } from 'lodash-es'
import { useFileUrlPrefix } from 'shj-utils'
import { SSkuCard, STableActions, SActionBtn } from "shj-components";
import { listProductSkuRelationSpuFormat } from '@/services/order'
import DragEditTable from '@/components/DragEditTable'
import ProductDetailDrawer from '@/components/ProductDetailDrawer'
import NotCombinatePriceModal from '@/pages/productManage/components/skuTreeSearchTable/components/notCombinatePriceModal'
import CombinatePriceModal from '@/pages/productManage/components/skuTreeSearchTable/components/combinatePriceModal'
import { batchUpdateQuoteSort } from '@/services/order'
import { productSkuDetail } from '@/services/product'
import { useSetState } from 'ahooks'
import { getUser } from 'shj-utils'
import KitDetailDialogV3 from '../KitDialog'
import styles from '../ProjectDetail/index.module.less';

const DragTable: React.FC = (props: any) => {
  const { dataSource, setDataSource, tableConfig = {}, chooseTab, flowData = {} } = props
  console.log(props, 'props');
  
  const user = getUser()
  const fileUrlPrefix = useFileUrlPrefix()
  const [packDtlList, setPackDtlList] = useState<any[]>([])
  const [openKitDialog, setOpenKitDialog] = useState(false)
  const [recordItem, setRecordItem] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [recordInfo, setRecordInfo] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [productDetailReadOnly, setProductDetailReadOnly] = useState(false)
  // 套件选择
  const [kitSku, setKitSku] = useState<any>({})
  const [kitSpu, setKitSpu] = useState<any>({})
  const [activityInfo, setActivityInfo] = useState<any>({})
  const [openNotComPriceModal, setOpenNotComPriceModal] = useState(false)
  const [openComPriceModal, setOpenComPriceModal] = useState(false)
  const [skuSourceType, setSkuSourceType] = useState('')
  const [chooseSkuId, setChooseSkuId] = useState('')
  const [previewObj, setPreviewObj] = useSetState<any>({
    open: false,
    loading: false,
    descType: [],
    data: {},
  })

    // 套件
  const handleKitDetail = async (record: any, item) => {
    setOpenKitDialog(true)
    setRecordItem(item)
    setRecordInfo(record)
    setKitSku({})
    setKitSpu({})
    // 判断是否可编辑
    setProductDetailReadOnly(false)
    if (item.quoteBudgetId !== flowData?.variables?.entity?.quoteBudgetId) {
      setProductDetailReadOnly(true)
    }

    try {
      const resData: any = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: flowData?.variables?.entity?.quoteBudgetId,
          budgetDtlId: item.id,
          productSkuId: item.prdSkuId,
          productSpuId: item.prdId,
          generalId:
            chooseTab === 'UP_DOWN' || chooseTab === 'GENERAL'
              ? record?.generalItemManageId || null
              : null,
          priceCalcType: chooseTab === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: record?.refActiveDtlId || null,
          quotationFlowId: flowData?.variables?.quotationFlowId
        },
      })
      const skuInfo = resData?.skuList?.find(el => el.id === item.prdSkuId) || []
      setKitSku(skuInfo)
      setKitSpu(resData)
      if (chooseTab === 'ACTIVITY') {
        setActivityInfo({
          activityId: item.refActiveId,
          activityProductId: item.refActiveDtlId,
        })
      }
      setPackDtlList(item?.packDtlList || [])
    } catch (error) {
      console.log(error)
    }
  }

  const closeKitDialog = (value: any) => {
    setOpenKitDialog(false)
  }

  const handleSearchPrice = async (item: any) => {
    if (item?.budgetDtlVoList?.[0]?.prodType === 'PRODUCT_GROUP') {
      setChooseSkuId(item?.budgetDtlVoList?.[0]?.prdSkuId)
      setOpenComPriceModal(true)
    } else {
      setSkuSourceType(item?.budgetDtlVoList?.[0]?.sourceType)
      setChooseSkuId(item?.budgetDtlVoList?.[0]?.prdSkuId)
      setOpenNotComPriceModal(true)
    }
  }

  const onOpenProductDetail = productId => {
    setPreviewObj({ open: true, loading: true })
    productSkuDetail(productId)
      .then(res => {
        setPreviewObj({
          data: res,
        })
      })
      .finally(() => setPreviewObj({ loading: false }))
  }

  // 表格配置
  const extension = {
    request: {},
    pagination: false,
    search: false,
    fieldControl: false,
    events: {},
    status: {},
    customRender: {
      isRequiredRender: (text: any, record: any) => {
        return (
          <p
            style={{
              color: record?.updateType === 'ADD' ? 'green' : record?.updateType === 'REMOVE' ? 'red' : '#333'
            }}
            className={text ? styles.isRequired : styles.isNotRequired}
          >
            {text ? '是' : '否'}
          </p>
        )
      },
      renderSku: (text: any, record: any) => {
        const list = record?.budgetDtlVoList || []
        if (isArray(list) && !!list?.length) {
          return list.map((item, index) => {
            return (
              <>
                {index != 0 && (
                  <Divider
                    style={{ margin: '4px 0', borderBlockStart: '1px dashed rgba(5, 5, 5, 0.06)' }}
                  />
                )}
                {/* 增项时可能也有通项 需要处理 */}
                {record.sourceType === 'GENERAL' && chooseTab === 'ADD' ? (<span>
                  <span style={{
                    marginRight: 10,
                    color: item?.updateType === 'ADD' ? 'green' : (item?.updateType === 'REMOVE') ? 'red' : '#333'
                  }}>{item.name}</span>
                </span>) : (
                  <div style={{ minHeight: '76px'}}>
                    <SSkuCard
                      key={index + '-' + record?.id + '-' + item?.id + '-' + item.prdSkuId}
                      width={'100%'}
                      url={
                        item?.mainPic
                          ? item.mainPic.startsWith('http')
                            ? item.mainPic
                            : fileUrlPrefix + item.mainPic
                          : 'https://static.shjmall.cn/sass/empty.png'
                      }
                      urlList={item?.imageUrls}
                      title={
                        <div
                          style={{
                            width: '100%',
                            color: item?.updateType === 'ADD' ? 'green' : (item?.updateType === 'REMOVE' || (item?.updateType === 'UPDATE' && item?.updateFields?.find(field => field.fieldEnum === 'PACK_DTL'))) ? 'red' : '#333'
                          }}
                          className={styles.skuTitle}
                        >
                          <Tooltip title={item?.name} placement="topLeft" autoAdjustOverflow>
                            <div
                              style={{ fontSize: '12px', fontWeight: '400', color: '#0064FF', cursor: 'pointer' }}
                              onClick={() => onOpenProductDetail(item.prdSkuId)}
                            >
                              {item?.name}
                            </div>
                          </Tooltip>
                        </div>
                      }
                      imgFit={false}
                      desc={<span
                        style={{ color: item?.updateType === 'ADD' ? 'green' : (item?.updateType === 'REMOVE') ? 'red' : '#333' }}
                        className={styles.skuDesc}
                        >SKU: {item.prdSkuId}</span>
                      }
                      imgFilter={
                        item?.skuWarnMessage ? (
                          <div dangerouslySetInnerHTML={{ __html: item?.skuWarnMessage }} />
                        ) : undefined
                      }
                      disabled={item?.skuWarnMessage}
                      operation={() => {
                        return (
                          <>
                            {
                              <>
                                {item.refType !== 'SUB' &&
                                  !item.refDeductId &&
                                  item.packDtlList &&
                                  !!item.packDtlList.length && (
                                    <Button
                                      size="small"
                                      type="primary"
                                      danger={(item?.updateType === 'REMOVE' || (item?.updateType === 'UPDATE' && item?.updateFields?.find(field => field.fieldEnum === 'PACK_DTL'))) ? true : false}
                                      ghost
                                      onClick={() => handleKitDetail(record, item)}
                                    >
                                      产品明细
                                    </Button>
                                  )}
                              </>
                            }
                          </>
                        )
                      }}
                    />
                  </div>
                )}
              </>
            )
          })
        } else {
          if (record.generalItemManageId && chooseTab === 'SUB') {
            // 减通项
            return (
              <>
                <span
                  style={{ marginRight: 10, color: record?.updateType === 'ADD' ? 'green' : record?.updateType === 'REMOVE' ? 'red' : '#333' }}
                >{record.name}</span>
              </>
            )
          } else if (!record.generalItemManageId && chooseTab === 'SUB') {
            // 减非通项
            return (
              <div style={{ minHeight: '76px'}}>
                <SSkuCard
                  key={record?.id + '-' + record.prdId}
                  width={'100%'}
                  url={
                    record?.mainPic
                      ? record.mainPic.startsWith('http')
                        ? record.mainPic
                        : fileUrlPrefix + record.mainPic
                      : 'https://static.shjmall.cn/sass/empty.png'
                  }
                  urlList={record?.imageUrls}
                  title={
                    <div
                      style={{
                        width: '100%',
                        color: record?.updateType === 'ADD' ? 'green' : record?.updateType === 'REMOVE' ? 'red' : '#333'
                      }}
                      className={styles.skuTitle}
                    >
                      <Tooltip title={record.name} placement="topLeft" autoAdjustOverflow>
                        <div
                          style={{ fontSize: '12px', fontWeight: '400', color: '#0064FF', cursor: 'pointer' }}
                          onClick={() => onOpenProductDetail(record.prdSkuId)}
                        >
                          {record.name}
                        </div>
                      </Tooltip>
                    </div>
                  }
                  imgFit={false}
                  desc={<span
                    className={styles.skuDesc}
                    style={{
                      color: record?.updateType === 'ADD' ? 'green' : record?.updateType === 'REMOVE' ? 'red' : '#333'
                    }}
                  >SKU: {record.prdSkuId}</span>}
                  imgFilter={
                    record?.skuWarnMessage ? (
                      <div dangerouslySetInnerHTML={{ __html: record?.skuWarnMessage }} />
                    ) : undefined
                  }
                  disabled={record?.skuWarnMessage}
                />
              </div>
            )
          }
        }
      },
      actionRender: (_, record: Record<string, any>) => {
        const list = chooseTab !== 'SUB' ? (record?.budgetDtlVoList || []) : [{...record}]
        return list.map((item, index) => {
          if (item?.prdSkuId && (flowData?.currentAuditList?.[0]?.nodeId === 'Activity_1dt25d3') && (item?.prodType !== 'PRODUCT_PACKAGE') && (flowData?.currentAuditList?.[0]?.nodeWorkNumberList?.includes(user?.userId))) {
            return (
              <div style={{ height: '76px', display: 'flex', alignItems: 'center' }}>
                <STableActions>
                  <SActionBtn onClick={() => {
                    handleSearchPrice({...record, budgetDtlVoList: [{...item}]})
                  }}>
                    价格查询
                  </SActionBtn>
                </STableActions>
              </div>
            )
          } else {
            return (
              <div style={{ height: '76px', display: 'flex', alignItems: 'center' }}>
                <STableActions>
                  <div></div>
                </STableActions>
              </div>
            )
          }
        })
      },
    },
    scroll: { x: 'max-content', y: '580px' },
    sticky: { offsetHeader: -8, getContainer: () => document.getElementById('table1') },
  } 

  const sortTable = (data: any) => {
    data = data?.map((item: any) => {
      if (chooseTab === 'SUB') {
        return item?.id
      } else {
        return item?.budgetDtlId
      }
    })
    batchUpdateQuoteSort({
      quotationFlowId: flowData?.variables?.quotationFlowId,
      quoteBudgetDtlIds: data
    }).then(() => {
      message.success('更新成功')
    })
  }

  return (
    <div>
       <DragEditTable
          rowKey="key"
          columns={tableConfig?.columns || []}
          dataSource={dataSource}
          setDataSource={setDataSource}
          showSortTitle={false}
          antdProps={{
            ...extension,
          }}
          noAttendDragHandler={true}
          sortTable={sortTable}
        ></DragEditTable>
      {/* 产品明细 */}
      {openKitDialog && (
        <KitDetailDialogV3
          budgetId={flowData?.variables?.entity?.quoteBudgetId}
          kitSku={kitSku}
          setKitSku={setKitSku}
          productInfo={kitSpu}
          open={openKitDialog}
          closeDialog={closeKitDialog}
          // combinationInfoList={combinationInfoList}
          packDtlList={packDtlList}
          selectType={chooseTab}
          activityInfo={activityInfo}
          generalId={recordInfo.generalItemManageId}
          recordItem={recordItem}
          readOnly={productDetailReadOnly}
          quotationFlowId={flowData?.variables?.quotationFlowId}
          okText="确定"
        />
      )}
      {openNotComPriceModal && (
        <NotCombinatePriceModal
          open={openNotComPriceModal}
          setOpen={setOpenNotComPriceModal}
          skuId={chooseSkuId}
          orgList={[{id: flowData?.variables?.companyId, companyName: '测试'}]}
          skuSourceType={skuSourceType}
          noSearch={true}
          defaultProductId={flowData?.variables?.entity?.productId}
        />
      )}
      {openComPriceModal && (
        <CombinatePriceModal
          open={openComPriceModal}
          setOpen={setOpenComPriceModal}
          skuId={chooseSkuId}
          orgList={[{id: flowData?.variables?.companyId, companyName: '测试'}]}
          noSearch={true}
          defaultProductId={flowData?.variables?.entity?.productId}
        />
      )}
      {previewObj.open && (
        <ProductDetailDrawer
          previewObj={previewObj}
          setPreviewObj={setPreviewObj}
        ></ProductDetailDrawer>
      )}
    </div>
  )
}

export default DragTable
